import {Observable}     from 'rxjs';
import {withLatestFrom} from 'rxjs/operators';

import Media          from '../../../State/Stores/Media/Media';
import PlaybackStatus from '../../../State/Stores/Playback/Constants/PlaybackStatus';

const createPlaybackStatusWithMediaStream = (
    playbackStatus$: Observable<PlaybackStatus>,
    mediaStoreUpdate$: Observable<Media>
): Observable<[PlaybackStatus, Media]> =>
    playbackStatus$
        .pipe(
            withLatestFrom(mediaStoreUpdate$)
        );

export default createPlaybackStatusWithMediaStream;